export default "__VITE_ASSET__CDoO7vCZ__"